import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormContext, Article, Button } from '../form-context';

const Text = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: #fff;
  > em {
    font-style: normal;
    color: ${props => props.theme.primaryColor};
  }
`;

const Title = styled(Text)`
  ${props => (props.theme.isPortrait ? `
    font-size: 23px;
    line-height: 25px;
  ` : `
    font-size: 40px;
    line-height: 40px;
  `)}
  text-transform: uppercase;
  margin: 0;
  margin-top: 50px;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SubTitle = styled(Text)`
  text-align: center;
  font-size: ${props => (props.theme.isPortrait ? 15 : 20)}px;
  line-height: ${props => (props.theme.isPortrait ? 20 : 30)}px;
  text-transform: uppercase;
  margin: 0;

  &:first-child {
    margin-top: 48px;
  }
`;

const Desc = styled(Text)`
  font-size: ${props => (props.theme.isPortrait ? 13 : 15)}px;
  line-height: 15px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export default function DownloadForm({ ebookName }) {
  const { state } = React.useContext(FormContext);

  function redirect(e) {
    if (e) {
      e.preventDefault();
    }
    window.location = '/';
  }

  React.useEffect(() => {
    setTimeout(redirect, 5000);
  }, []);

  return (
    <Article>
      <Title>Thank you</Title>
      <Div>
        <SubTitle>
          {'We’ve sent your '}
          <em>{ebookName}</em>
          {' ebook to your email address'}
        </SubTitle>
        <SubTitle>{state.email}</SubTitle>
      </Div>
      <Desc>
        We’ll redirect you to Livewiremarkets.com to discover more income generating ideas.
      </Desc>
      <Button type="button" onClick={redirect}>Take me to Livewire Markets</Button>
    </Article>
  );
}

DownloadForm.propTypes = {
  ebookName: PropTypes.string.isRequired,
};
